// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const TaskEditorContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-taskeditorcontainer" */ "./taskEditorContainer/TaskEditorContainer")).then((bundle)=>{
        return {
            default: bundle.TaskEditorContainer
        };
    });
export const LazyTaskEditorContainer = /*#__PURE__*/ lazy(TaskEditorContainerLazyLoader);
